// extracted by mini-css-extract-plugin
export default {"infoWrapper":"Map_infoWrapper__eFAuh","infoTitle":"Map_infoTitle__AtzLW","infoVolume":"Map_infoVolume__gBbdm","infoName":"Map_infoName__rNH0X","infoFio":"Map_infoFio__4qdZ5"};